<template>
  <div>
    <button v-if="!isDownloading" :class="clases" type="button" @click="getDocument" :disabled="isDownloading">{{titulo}}</button>
    <button v-if="isDownloading" :class="clases" type="button" style="border-radius: 3px;" disabled>
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        <span class="mx-1">{{titulo}}</span>
    </button>
  </div>
</template>

<script>
import axios from 'axios'
import { utils } from '@/utils.js'

export default {
  mixins: [utils],
  props: {
    titulo: {
      type: String,
      default: 'Vacio'
    },
    clases: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    parametros: {
      type: Object,
      default: () => {}
    },
    outputName: {
      type: String,
      default: 'output'
    },
    tipo: {
      type: String,
      default: 'xlsx'
    }
  },
  data () {
    return {
      isDownloading: false
    }
  },
  methods: {
    getDocument () {
      let tipoDocumento = ''
      let extension = ''

      const tiposDocumento = {
        xls: 'application/vnd.ms-excel',
        xlsx: 'application/vnd.ms-excel',
        csv: 'text/csv',
        pdf: 'application/pdf',
        doc: 'application/msword',
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        png: 'image/png',
        jpg: 'image/jpeg',
        ppt: 'application/vnd.ms-powerpoint',
        pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        zip: 'application/zip',
        rar: 'application/vnd.rar'
      }

      extension = `.${this.tipo}`
      tipoDocumento = tiposDocumento[this.tipo]
      if (tipoDocumento === undefined || tipoDocumento === null) {
        console.log('El tipo indicado en el boton es incorrecto')
        return
      }

      this.isDownloading = true
      const queryParams = this.parametros
      console.log('datos', tipoDocumento, extension, this.outputName)
      axios.get(this.url, { params: queryParams, responseType: 'blob' }).then(res => {
        const url = URL.createObjectURL(new Blob([res.data], {
          type: tipoDocumento
        }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', this.outputName + extension)
        document.body.appendChild(link)
        link.click()
        this.isDownloading = false
      }).catch(() => {
        this.isDownloading = false
        this.errorNotification('Ha ocurrido un problema con la descarga')
      })
    }
  }

}
</script>

<style>

</style>
